module.exports = __webpack_public_path__ + "static/media/gc-athens-beach.07672cdb.png";